import { useMutation } from "@tanstack/react-query";
import { Narendra_Modi_Election_API_URL } from "../Process";

// ********************************************************************Mukesh Patel Election***********************************************************

export const useDeleteMember = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const API_URL = `${Narendra_Modi_Election_API_URL}removeMember`;

      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Something went wrong");
      }

      const data = await response.json();
      return data;
    },
  });
};
export const useDeleteYojnaDetails = () => {
  return useMutation({
    mutationFn: async (payload) => {
      const API_URL = `${Narendra_Modi_Election_API_URL}removeVoterYojnaDetail`;

      const response = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Something went wrong");
      }

      const data = await response.json();
      return data;
    },
  });
};

